import ProxyBase from '../../ProxyBase';
import ServiceProxyConfig from '../../../../configs/ServiceProxyConfig';

class LiquidityProxy extends ProxyBase {
  getLiquiditySeries(data, source) {
    return this.get('GetLiquiditySeries', data, source);
  }

  getBuSd(params) {
    return this.get('GetComGroupBuSdChart', params);
  }
}

const liquidityProxy = new LiquidityProxy(
  ServiceProxyConfig.Market.MarketInDepth.ServiceUrl,
);
export default liquidityProxy;
